import {InjectionToken} from "@angular/core";

export const INT_MONTH_LIST_TOKEN = new InjectionToken<Array<string>>('INT_MONTH_LIST_TOKEN', {
  factory() {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  }
});
